import React, {ReactNode} from 'react';
import {Helmet} from 'react-helmet-async';
import cn from 'classnames';

import Table, {ITableProps} from 'shared/ui/Table/Table';

import TableBox from '../Box/TableBox/TableBox';

import styles from './ListPage.module.scss';

export const listPageClassName = styles.containerPage;

interface IListPageProps<T extends object> extends Omit<ITableProps<T>, 'className'> {
    documentTitle: string,
    toolbar: ReactNode,
    actions?: ReactNode,
    plug?: ReactNode,
    children?: ReactNode,
}

function ListPage<T extends object>({
    documentTitle,
    toolbar,
    actions,
    plug,
    children,
    ...tableProps
}: IListPageProps<T>) {
    return (
        <TableBox className={styles.container}>
            <Helmet>
                <title>{documentTitle}</title>
            </Helmet>
            <div className={cn(styles.title, !actions && styles.titleWithoutActions)}>
                {toolbar}
                {actions}
            </div>

            <Table {...tableProps} className={styles.table}/>
            {plug}
            {children}
        </TableBox>
    );
}

export default ListPage;
